<template>
  <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
    <v-row justify="center" align="center">
      <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
    </v-row>
    <v-row justify="center" align="center">
      <v-card-subtitle class="subtitle-1"
        >You do not have Permission to access.</v-card-subtitle
      >
    </v-row>
  </v-card>
  <v-card max-width="100%" class="pa-0 mt-0 elevation-0" v-else>
    <v-card-text flat>
      <v-data-table
        dense
        :headers="headers"
        :items="itemsub"
        :search="search_text"
        label="Subscription"
        item-key="name"
      >
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">
            {{ itemsub.indexOf(item) + 1 }}
          </span>
        </template>
        <template v-slot:[`item.card_type`]="{ item }">
          <span class="caption" v-if="item.card_type == 1">
            Non-Personalized
          </span>
          <span class="caption" v-if="item.card_type == 2"> Personalized </span>
        </template>
        <template v-slot:[`item.pack_name`]="{ item }">
          <span class="caption">
            {{ item.pack_name }}
          </span>
        </template>
        <template v-slot:[`item.annual_fee`]="{ item }">
          <span class="caption"> {{ item.annual_fee }} </span>
        </template>
        <template v-slot:[`item.subs_start_date`]="{ item }">
          <span class="caption"> {{ item.subs_start_date }} </span>
        </template>
        <template v-slot:[`item.subs_end_date`]="{ item }">
          <span class="caption"> {{ item.subs_end_date }} </span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span class="caption green--text" v-if="item.status == 'Active'">
            ACTIVE
          </span>
        </template>
        <template v-slot:[`item.quantity`]="{ item }">
          <span class="caption" v-if="Active"> {{ item.quantity }} </span>
        </template>
        <template v-slot:[`item.pack_code`]="{ item }">
          <span class="caption" v-if="item.pack_code != null">
            {{ item.pack_code }}
          </span>
          <span class="caption" v-else> - </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon @click="showContent(item)" small class="mr-2" color="primary"
            >mdi-eye</v-icon
          >
        </template>

        <template v-slot:top>
          <v-row>
            <v-card-title class="primary--text mt-n4"
              ><v-btn @click="back" class="ml-n7 primary--text" text>
                <v-icon>mdi-reply</v-icon></v-btn
              >Subscription
              <span
                style="
                  font-style: italic;
                  font-family: Times New Roman;
                  font-size: 14px;
                "
                class="text-left font-weight: 20 primary--text ml-2"
                >(Pack Subscription Details)</span
              >
            </v-card-title>

            <v-spacer></v-spacer>

            <v-col lg="3" xl="3" md="3" sm="12" xs="12">
              <v-text-field
                dense
                class="mr-n0 mt-0"
                v-model="search_text"
                append-icon="mdi-magnify"
                label="Search"
                shaped
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="subscriptiondialog" width="600">
        <v-card class="elevation-0">
          <v-toolbar dark class="elevation-0 header" dense>
            <v-icon>mdi-cart-outline</v-icon>
            <span class="ml-3">Subscription</span>
            <v-spacer></v-spacer>
            <v-btn class text dark @click="subscriptiondialog = false">
              <v-icon color="white" small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-card
              elevation="1"
              width="900"
              height="auto"
              class="mb-4 mt-6"
              shaped
            >
              <v-row>
                <v-col cols="12" md="6" lg="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Corporate Name</b>
                      </span>
                      <br />
                      <span class="caption" v-if="StoreObj.corp_name != ''">
                        {{ StoreObj.corp_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Pack Name</b>
                      </span>
                      <br />
                      <span class="caption" v-if="StoreObj.pack_name != ''">
                        {{ StoreObj.pack_name }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Number Of Cards</b>
                      </span>
                      <br />
                      <span class="caption" v-if="StoreObj.quantity != ''">
                        {{ StoreObj.quantity }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Monthly Fee</b>
                      </span>
                      <br />
                      <span class="caption" v-if="StoreObj.monthly_fee != ''">
                        {{ StoreObj.monthly_fee }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Annual Fee</b>
                      </span>
                      <br />
                      <span class="caption" v-if="StoreObj.annual_fee != ''">
                        {{ StoreObj.annual_fee }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Subscription Start Date</b>
                      </span>
                      <br />
                      <span
                        class="caption"
                        v-if="StoreObj.subs_start_date != ''"
                      >
                        {{ StoreObj.subs_start_date }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Subscription End Date</b>
                      </span>
                      <br />
                      <span class="caption" v-if="StoreObj.subs_end_date != ''">
                        {{ StoreObj.subs_end_date }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                  <v-row class="ml-3">
                    <v-col cols="12" md="12" lg="12">
                      <span class="subtitle-2">
                        <b class="primary--text">Status</b>
                      </span>
                      <br />
                      <span class="caption" v-if="StoreObj.status != ''">
                        {{ StoreObj.status }}
                      </span>
                      <span class="caption ml-2" v-else> - </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <!-- <v-card-text class="mt-1">
            <v-row class="ml-n1">
              <v-col cols="4">
                <v-row class="mt-3">
                  <span class="subtitle-2">
                    <b class="primary--text">Corporate Name :</b>
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span class="subtitle-2">
                    <b class="primary--text">Pack Name :</b>
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span class="subtitle-2">
                    <b class="primary--text">Pack Code :</b>
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span class="subtitle-2">
                    <b class="primary--text">No Of Cards:</b>
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span class="subtitle-2">
                    <b class="primary--text">Monthly Fee (MYR) :</b>
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span class="subtitle-2">
                    <b class="primary--text">Annual Fee (MYR) :</b>
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span class="subtitle-2">
                    <b class="primary--text">Subscription Start Date :</b>
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span class="subtitle-2">
                    <b class="primary--text">Subscription End Date :</b>
                  </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span class="subtitle-2">
                    <b class="primary--text">Status :</b>
                  </span>
                  <br />
                </v-row>
              </v-col>
              <v-col cols="8">
                <v-row class="mt-3">
                  <span
                    class="subtitle-2 black--text"
                    v-if="StoreObj.corp_name != ''"
                  >
                    {{ StoreObj.corp_name }}
                  </span>
                  <span class="subtitle-2 black--text" v-else> - </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span
                    class="subtitle-2 black--text"
                    v-if="StoreObj.pack_name != ''"
                  >
                    {{ StoreObj.pack_name }}
                  </span>
                  <span class="subtitle-2 black--text" v-else> - </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span
                    class="subtitle-2 black--text"
                    v-if="StoreObj.pack_code != ''"
                  >
                    {{ StoreObj.pack_code }}
                  </span>
                  <span class="subtitle-2 black--text" v-else> - </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span
                    class="subtitle-2 black--text"
                    v-if="StoreObj.quantity != ''"
                  >
                    {{ StoreObj.quantity }}
                  </span>
                  <span class="subtitle-2 black--text" v-else> - </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span
                    class="subtitle-2 black--text"
                    v-if="StoreObj.monthly_fee != ''"
                  >
                    {{ StoreObj.monthly_fee }}
                  </span>
                  <span class="subtitle-2 black--text" v-else> - </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span
                    class="subtitle-2 black--text"
                    v-if="StoreObj.annual_fee != ''"
                  >
                    {{ StoreObj.annual_fee }}
                  </span>
                  <span class="subtitle-2 black--text" v-else> - </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span
                    class="subtitle-2 black--text"
                    v-if="StoreObj.subs_start_date != ''"
                  >
                    {{ StoreObj.subs_start_date }}
                  </span>
                  <span class="subtitle-2 black--text" v-else> - </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span
                    class="subtitle-2 black--text"
                    v-if="StoreObj.subs_end_date != ''"
                  >
                    {{ StoreObj.subs_end_date }}
                  </span>
                  <span class="subtitle-2 black--text" v-else> - </span>
                  <br />
                </v-row>
                <v-row class="mt-6">
                  <span
                    class="subtitle-2 black--text"
                    v-if="StoreObj.status != ''"
                  >
                    {{ StoreObj.status }}
                  </span>
                  <span class="subtitle-2 black--text" v-else> - </span>
                  <br />
                </v-row>
              </v-col>
            </v-row>
          </v-card-text> -->
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: {},
  data: () => ({
    checkaccessdata: {},
    addsubscription: false,
    subscriptiondialog: false,
    itemsub: [],
    search_text: "",
    corpList: [],
    StoreObj: {},
    corpId: 0,
    headers: [
      {
        text: "SL NO",
        align: "start",
        sortable: false,
        value: "sl_no",
      },
      {
        text: "PACK CODE",
        align: "start",
        value: "pack_code",
        sortable: false,
      },
      {
        text: "CARD TYPE",
        align: "start",
        value: "card_type",
        sortable: false,
      },
      {
        text: "PACK NAME",
        align: "start",
        value: "pack_name",
        sortable: false,
      },
      {
        text: "AMOUNT (MYR)",
        value: "annual_fee",
        sortable: false,
      },
      {
        text: "SUBSCIPTION START DATE",
        align: "start",
        sortable: false,
        value: "subs_start_date",
      },

      { text: "SUBSCIPTION END DATE", value: "subs_end_date", sortable: false },
      // { text: "SUSPENSION FEE", value: "bal_left", sortable: false },

      { text: "STATUS", value: "status", sortable: false },
      { text: "ACTION", value: "actions", align: "start", sortable: false },
    ],
  }),
  created() {
    // this.getCropName();
    this.checkaccess();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CARDS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.subscription();
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },
    opensubscriptiondialog() {
      this.addsubscription = true;
    },
    showContent(item) {
      this.subscriptiondialog = true;
      this.StoreObj = item;
    },
    async subscription() {
      this.overlay = true;
      var inputData = {
        method_name: "ADMINBIL",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "GETSUBS",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responseData", responseData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.itemsub = responseData.data.data;
      }
      this.overlay = false;

      // console.log("  this.tableDataApproval", this.tableDataApproval);
    },
    // async getCropName() {
    //   var inputData = {
    //     method_name: "ADMINCARDS",
    //     page_no: 1,
    //     record_count: 0,
    //     page_size: null,
    //     app_code: "APORTAL",
    //     status: "",
    //     method_param: {
    //       action: "GETCOP",
    //       search_text: "",
    //       corp_id: 0,
    //     },
    //   };
    //   var responseData = await apiCall(inputData);
    //   this.corpList = responseData.data.data;

    //   this.corpList.unshift({
    //     corp_id: 0,
    //     corp_name: "All",
    //   });
    // },
  },
};
</script>
